import { useMemo } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useLocation } from "react-router-dom";

import { getLocaleFromPath, Locale, localePath } from "../i18n/config";

const footerLabels: Record<string, Record<Locale, string>> = {
    home:       { fi: "Koti", en: "Home", sv: "Hem" },
    contact:    { fi: "Yhteystiedot", en: "Contact", sv: "Kontakt" },
    companies:  { fi: "Yrityksille", en: "For Businesses", sv: "För företag" },
    login:      { fi: "Kirjaudu", en: "Log In", sv: "Logga in" },
    terms:      { fi: "Tietosuoja | Palveluehdot", en: "Privacy | Terms of Service", sv: "Integritet | Användarvillkor" },
};

const Links = () => {
    const { pathname } = useLocation();
    const locale = getLocaleFromPath(pathname);
    const t = (key: string) => footerLabels[key]?.[locale] ?? footerLabels[key]?.fi ?? key;

    const paths = useMemo(() => ({
        home:         localePath("home"),
        yhteydenotto: localePath("yhteydenotto"),
        yrityksille:  localePath("yrityksille"),
        kirjaudu:     localePath("kirjaudu"),
        palveluehdot: localePath("palveluehdot"),
    }), [pathname, locale]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Navbar className="links">
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="global-links-container">
                    <LinkContainer to={paths.home}>
                        <Nav.Link className="page-links">{t("home")}</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={paths.yhteydenotto}>
                        <Nav.Link className="page-links">{t("contact")}</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={paths.yrityksille}>
                        <Nav.Link className="page-links">{t("companies")}</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={paths.kirjaudu}>
                        <Nav.Link className="page-links">{t("login")}</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={paths.palveluehdot}>
                        <Nav.Link className="page-links">{t("terms")}</Nav.Link>
                    </LinkContainer>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default Links;
